// extracted by mini-css-extract-plugin
module.exports = {"bottomLeft":"styles-module--bottomLeft--2pk43","centered":"styles-module--centered--3dp3t","overlay":"styles-module--overlay--1ogIu"};